import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Trans } from '@lingui/react'
import compose from 'lodash/fp/compose'

import errorBoundary, {
  ErrorBoundaryProps,
} from 'client/shared/decorators/error-boundary'
import urlFor from 'shared/tools/url-helper'
import deviceHelper from 'shared/tools/device-helper'
import navHelper from 'client/bookmate/helpers/nav-helper'

import { getShelfById } from 'client/bookmate/reducers/shelves-reducer'

import StoreButtonBox from 'client/shared/boxes/store-button-box'
import FollowButtonBox from 'client/bookmate/boxes/follow-button-box'

import Button from 'client/shared/blocks/button'
import DeeplinkButton from 'client/shared/blocks/deeplink-button'
import { SubHeader } from 'client/bookmate/blocks/sub-header'
import FloatingAction from 'client/shared/blocks/floating-action'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { Dispatch, State } from 'shared/types/redux'
import { FullShelfProps } from 'client/shared/types/shelf'

type Props = {
  shelf: FullShelfProps
  kind: 'default' | 'full'
  dispatch: Dispatch
  loading: boolean
  app: AppState
} & ErrorBoundaryProps

class ShelfSubHeaderBox extends Component<Props> {
  static defaultProps = {
    kind: 'default',
    loading: false,
  }

  render() {
    if (!this.props.shelf) return null

    const {
      app,
      kind,
      shelf,
      loading,
      dispatch,
      shelf: { title, creator, uuid, editable },
    } = this.props

    const isMobileOS = deviceHelper.isMobileOS(app)

    return (
      <SubHeader
        previewLink={urlFor.shelf(uuid, app.storedQuery)}
        title={title}
        authors={creator?.name || creator?.login}
        renderButton={
          isMobileOS ? (
            <StoreButtonBox inverted size="small" />
          ) : editable ? (
            <Button
              kind="primary"
              type="inline"
              loading={loading}
              width="100%"
              onClick={e => {
                e?.preventDefault()
                dispatch(
                  push(urlFor.shelfChooseBooksToAdd(uuid, app.storedQuery)),
                )
              }}
            >
              <Trans id="shelf.add_book" />
            </Button>
          ) : (
            <FollowButtonBox
              shelf={shelf}
              following={shelf.following}
              loading={loading}
              width="160px"
            />
          )
        }
        renderFloatingAction={this.renderFloatingAction}
        nav={navHelper.shelfNav(shelf, app.storedQuery)}
        fixed={['full'].includes(kind)}
        kind={kind}
      />
    )
  }

  renderFloatingAction = () => {
    const { shelf } = this.props

    return (
      <FloatingAction>
        <DeeplinkButton
          resourceType="shelf"
          uuid={shelf.uuid}
          stage="floating"
        />
      </FloatingAction>
    )
  }
}

const connectWrapper = connect((state: State) => ({
  app: state.app,
  loading: state.shelf.loading,
  shelf: getShelfById(state, state.shelf.uuid),
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(ShelfSubHeaderBox)
